/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import React from 'react';

import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { dispatch } from 'src/store';

//import { Input } from 'src/components/Antd';

import { ModuleCart, Preview } from '@/src/constrains';
import ResponsiveEditSwitcher from 'src/constrains/ResponsiveLayerEditor';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import {
  //  generateArticleCarousel,
  IParams,
} from 'src/pages/SalesChannelContentEditor/common';
import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/tools';
// import { EnumStatus, EnumProductType } from 'src/types/common/product';
// import { EnumLinkType } from 'src/types/common/linkType';
import { ContentModuleGroupPreloadingWrapper } from '@/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import PreviewContainer, {
  PreviewStyleSwitch,
} from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';
import ContentGroup from 'src/constrains/DraggableModules/ContentGroup';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import {
  fetchContentHomepage,
  getCollapseOpenStatus,
  getCollapseStatus,
  getCollapseValidationMsgDisplay,
  getContent,
  getEntityUuid,
  getH1TagUuid,
  getHasModified,
  getLoaded,
  getOpeningCollapse,
  getOrder,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getVisibleCollapse,
  moduleContentDynamicOnChange,
  moduleContentOnChange,
  moduleContentStaticOnChange,
  onChanged,
  onCollapseOpen,
  onContentListResponsiveLayerEditSubmit,
  onDuplicate,
  onErrorChange,
  onModuleReset,
  onModuleTypeChange,
  resetData,
  submitContentHomepage,
  validation,
} from './slice';
import TopConfigs from './TopConfigs';

import styles from './css.less';

import { useGenerateModules } from 'src/constrains/DraggableModules/useModules';
import { handleOnClear } from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit/tool';
import { beforeSubmit } from 'src/constrains/ResponsiveLayerEditor/tools';
import { useSalesChannelSubmit } from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/useSubmit';
import {
  isInPCorNative,
  isNative,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
// import {
//   I18nContext,
//   getCurrentLanguageSet,
// } from '../../../../locale/IntlProvider/IntlProvider';
// import { ELang } from 'src/types/common/language';
// import { Form, Spin, Input } from 'antd';

import ContentReverseIcon from 'src/constrains/ContentReverseIcon';
import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EnumPageType } from 'src/types/common';
const SalesChannelEditorHomepage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded: _loaded,
    isOnPrimaryLanguage,
    currentStyle,
    currentSize,
    isMini,
  } = props;

  const _isInPC = isInPCorNative(currentStyle, currentSize);
  const _isNative = isNative(currentStyle);

  const h1TagUuid = useSelector(getH1TagUuid());
  const entityUuid = useSelector(getEntityUuid());
  const selectedLanguage = useSelector(currentSelectedLanguage());

  const _d = useDispatch();
  const order = useSelector(getOrder());

  const handleOnChanged = () => {
    _d(onChanged());
  };
  // const err = useSelector(
  //   (state) => state.salesChannelContent.homepage.collapseErrorMsgDisplay,
  // );
  // console.log(err);
  const _params: IParams = useParams();

  const { contentUuid, saleChannelUuid } = _params;

  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });

  React.useEffect(() => {
    return () => {
      _d(resetData());
    };
  }, []);

  // const data = useSelector((state) => state.salesChannelContent.homepage);
  // console.log(data);

  const handleOnModuleContentStaticChange = (obj) => {
    _d(moduleContentStaticOnChange(obj));
  };

  const handleOnModuleContentDynamicChange = (obj) => {
    _d(moduleContentDynamicOnChange(obj));
  };

  const handleOnModuleOrderListChange = (obj) => {
    _d(moduleContentOnChange(obj));
  };

  const handleOnCollapseOpen = (idArr) => {
    _d(onCollapseOpen({ idArr }));
  };

  const handleOnModuleTypeChange = (data) => {
    //
    _d(onModuleTypeChange(data));
  };

  const handleOnDuplicate = (data) => {
    _d(onDuplicate(data));
  };

  const handleOnModuleReset = (data) => {
    _d(onModuleReset(data));
  };
  // const fetchData = () => {};

  const moduleList = useGenerateModules(currentStyle, moduleContentOnChange);

  const handleOnResponsiveEditSubmit = (data, cb?) => {
    _d(onContentListResponsiveLayerEditSubmit(data));
    if (cb) cb();
  };
  // const { setLang, lang } = React.useContext(I18nContext);
  // const langSet = getCurrentLanguageSet(lang);
  // const [i, setI] = React.useState('');
  // const [form1] = Form.useForm();

  return (
    <ContentModuleGroupPreloadingWrapper
      saleChannelUuid={saleChannelUuid}
      contentUuid={contentUuid}>
      {/* <button
        onClick={() => {
          setLang(ELang['zh-CN']);
        }}>
        qie cn
      </button>
      <button
        onClick={() => {
          setLang(ELang['en-GB']);
        }}>
        qie en
      </button>
      <button
        onClick={() => {
          console.log(form1.getFieldsValue());
        }}>
        say
      </button>
      title:{langSet['nb']}{' '}
      <Input
        value={i}
        onChange={(e) => {
          setI(e.target.value);
        }}
      />
      <Form form={form1}>
        <Form.Item name='test'>
          <Input />
        </Form.Item>
      </Form> */}
      <React.Fragment>
        <RouteBlock getHasModified={getHasModified} />
        <PageWrapper
          rarePart={
            _loaded ? (
              <ContentReverseIcon
                salesChannelUuid={saleChannelUuid}
                entityUuid={entityUuid}
                locale={selectedLanguage}
                entityType={EnumPageType.ContentHomePage}
                onReload={({ qParams }) => {
                  _d(
                    fetchContentHomepage({
                      //1===true 0===false
                      uuid: contentUuid,
                      params: qParams,
                    }),
                  );
                }}
              />
            ) : (
              <React.Fragment />
            )
          }
          customSubmit={() => {
            beforeSubmit(onContentListResponsiveLayerEditSubmit);
            setTimeout(() => {
              const a = submitData();
              const { submitFunction, isDataValid } = a || {};
              useSalesChannelSubmit({
                isValid: isDataValid,
                submit: submitFunction,
                status: salesChannel.status,
                avoidSubmitWhenHasError: false,
                getI18n,
              });
            }, 100);
          }}
          headerConfig={{
            hasModified,
            submit: submitData,
            salesChannelContentData: salesChannel || {},
            salesChannelName,
            onDiscard,
            onGoBack,
            hasStyleSelect: true && !isMini,
            submitLoading: !_loaded,
            // onContentReverse: {
            //   // onLoadChange: () => {
            //   //   _d(onLoadedChange(false));
            //   // },
            // onGetData: (params, qParams) => {
            //   const { contentUuid } = params;
            //   _d(
            //     fetchContentHomepage({
            //       //1===true 0===false
            //       uuid: contentUuid,
            //       params: qParams,
            //     }),
            //   );
            // },
            // },
          }}
          leftChild={
            <PreviewStyleSwitch
              style={currentStyle}
              styleChild={
                <div
                  style={{
                    height: 10000,
                    backgroundColor: 'transparent',
                    // margin: '0 auto',
                  }}>
                  123
                </div>
              }
              normalChild={
                <div className={styles.left}>
                  <PreviewContainer>
                    <Preview
                      order={order}
                      getContent={getContent}
                      getCollapseStatus={getCollapseStatus}
                    />
                  </PreviewContainer>
                </div>
              }
            />
          }
          rightChild={
            <ResponsiveEditSwitcher
              config={{
                isPrimary: isOnPrimaryLanguage,
                siteStyle: currentStyle,
                breakpoint: currentSize,
              }}
              onChanged={handleOnChanged}
              onSubmit={handleOnResponsiveEditSubmit}>
              <div className={styles.rightContainer}>
                <div className={styles.moduleCart}>
                  {_isInPC && <ModuleCart moduleList={moduleList} />}
                </div>

                {_loaded ? (
                  <RightConfigWrapper
                    title={'Home Page'}
                    elements={[
                      // {
                      //   body: <Input id='hallo' className={styles.test} />,
                      //   key: 'asd',
                      // },
                      {
                        body: _isInPC ? (
                          <TopConfigs
                            isNative={_isNative}
                            contentUuid={contentUuid}
                            // linkSet={linkSet}
                            isPrimaryLanguage={isOnPrimaryLanguage}
                          />
                        ) : null,
                        key: 'TopSettingContent',
                      },
                      {
                        key: 'moduleContent',
                        body: (
                          <ContentGroup
                            onDuplicate={handleOnDuplicate}
                            onModuleReset={handleOnModuleReset}
                            disabled={!_isInPC}
                            getCollapseOpenStatus={getCollapseOpenStatus}
                            onCollapseOpen={handleOnCollapseOpen}
                            getOpeningCollapse={getOpeningCollapse}
                            getContent={getContent}
                            droppableId={'SalesChannelEditorHomepage'}
                            data={order}
                            onModuleTypeChange={handleOnModuleTypeChange}
                            onOrderListOnChange={handleOnModuleOrderListChange}
                            onDynamicChange={handleOnModuleContentDynamicChange}
                            onStaticChange={handleOnModuleContentStaticChange}
                            linkSet={linkSet}
                            getErrorDisplay={getCollapseValidationMsgDisplay}
                            onErrorChange={onErrorChange}
                            getVisibleCollapse={getVisibleCollapse}
                            getCollapseStatus={getCollapseStatus}
                            extraProps={{
                              h1TagUuid: h1TagUuid,
                              siteStyle: currentStyle,
                              breakpoint: currentSize,
                            }}
                          />
                        ),
                      },
                    ]}
                  />
                ) : null}
              </div>
            </ResponsiveEditSwitcher>
          }
        />
      </React.Fragment>{' '}
    </ContentModuleGroupPreloadingWrapper>
  );
};

export default BasicPageHOC(SalesChannelEditorHomepage, {
  beforeRequest: handleOnClear,
  siteStyleInParams: true,
  previewSizeInParams: true,
  getState: getState,
  convertDataFromReduxToServer,
  submit: submitContentHomepage,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentHomepage({
        //1===true 0===false
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
